<script>
import MapLabelsContainer from "./labels/labels-container";
import OutdoorView from "./views/outdoor/outdoor-view";
import MvDataLayer from "./mv-data-layer";
import {
    MAP_SHOW_PATH,
    SET_GYROSCOPE_STATE,
    GET_UNIT_DISTANCES,
    MAP_HIGHLIGHT_UNITS,
    SET_NORMALIZED_ZOOM,
    REQUEST_CAMERA_ORIENTATION,
    RESPONSE_CAMERA_ORIENTATION, TURN_ON_DEVICE_ORIENTATION_EVENTS, DISABLE_TOUCH_HORIZONTAL_ROTATION
} from "./constants/map-commands";
import {
    MAP_SHOW_PATH_STEPS,
    START_VIEW_API,
    STOP_VIEW_API, UI_INNER_MAP_READY, UI_MAP_LOADED,
    UI_MAP_LOADING_PROGRESS,
    UI_MAP_READY
} from "./constants/map-events";
import Decimal from "decimal.js";

export default {
    name: 'MapViewer',
    props:{
        mapData: { type:Object, required: true },
        activeView: { type:String, default: 'OutdoorView' },
        listenEvents: { type: Boolean, default: true },
        isReactive: { type: Boolean, default: true },
    },
    components:{
        MvDataLayer,
        OutdoorView,
        MapLabelsContainer,
    },
    data(){
        return {
            mapViewerUrl: `${process.env.BASE_URL || '/static/'}mapsviewer/index.html`,
            dataSent: false,
            consoleDebug: this.$route.query.console || process.env.VUE_APP_DEBUG === 'true',
            mapDebugMenu: this.$route.query.mapMenu,
            mapDirectCommandMode: false,
            isLoaded: false,

            isMapReady: false,
        }
    },
    provide() {
        return {
            mapViewer: this,
        }
    },
    watch:{
        activeView(){ this.$emit('update:activeView', this.activeView) },

        listenEvents(){
            if(this.listenEvents)
                this.viewApi.start()
            else
                this.viewApi.stop()
        }
    },
    mounted(){
        console.log('Map Viewer Mounted')
        this.$refs.mapFrame.onload = () => {
            this.$bus.$emit(UI_MAP_LOADED)
            this.isLoaded = true
        };
        this.initEventListeners()
    },
    methods:{
        initEventListeners(){
            // Listen App
            this.deactivateEventListeners()

            this.$bus.$on(MAP_HIGHLIGHT_UNITS, this.highlightUnits);

            this.$bus.$on(MAP_SHOW_PATH, this.showPath);
            this.$bus.$on(MAP_SHOW_PATH_STEPS, this.showPathSteps);

            this.$bus.$on(STOP_VIEW_API, this.stopViewApi);
            this.$bus.$on(START_VIEW_API, this.startViewApi);

            this.$bus.$on(UI_MAP_LOADING_PROGRESS, this.mapLoadingProgressHandler);
            this.$bus.$on(UI_INNER_MAP_READY, this.mapReadyHandler);

            this.$bus.$on(SET_NORMALIZED_ZOOM, this.setNormalizedZoom);
            this.$bus.$on(GET_UNIT_DISTANCES, this.getUnitDistances);

            this.$bus.$on(REQUEST_CAMERA_ORIENTATION, this.responseCameraOrientation);
            this.$bus.$on(SET_GYROSCOPE_STATE, this.setStateGyroscope);
            this.$bus.$on(TURN_ON_DEVICE_ORIENTATION_EVENTS, this.turnOnDeviceOrientationEvents);
            this.$bus.$on(DISABLE_TOUCH_HORIZONTAL_ROTATION, this.disableTouchRotation);

            this.bindEvent(window, 'message', this.mapEventHandler);

        },
        deactivateEventListeners(){
            this.$bus.$off(MAP_HIGHLIGHT_UNITS, this.highlightUnits);

            this.$bus.$off(MAP_SHOW_PATH, this.showPath);
            this.$bus.$off(MAP_SHOW_PATH_STEPS, this.showPathSteps);

            this.$bus.$off(STOP_VIEW_API, this.stopViewApi);
            this.$bus.$off(START_VIEW_API, this.startViewApi);

            this.$bus.$off(UI_MAP_LOADING_PROGRESS, this.mapLoadingProgressHandler);
            this.$bus.$off(UI_INNER_MAP_READY, this.mapReadyHandler);

            this.$bus.$off(SET_NORMALIZED_ZOOM, this.setNormalizedZoom);
            this.$bus.$off(GET_UNIT_DISTANCES, this.getUnitDistances);

            this.$bus.$off(REQUEST_CAMERA_ORIENTATION, this.responseCameraOrientation);
            this.$bus.$off(SET_GYROSCOPE_STATE, this.setStateGyroscope);
            this.$bus.$off(TURN_ON_DEVICE_ORIENTATION_EVENTS, this.turnOnDeviceOrientationEvents);
            this.$bus.$off(DISABLE_TOUCH_HORIZONTAL_ROTATION, this.disableTouchRotation);

            this.unBindEvent(window, 'message', this.mapEventHandler);
        },

        mapEventHandler(e) {
            try {
                const msg = JSON.parse(e.data)
                this.$bus.$emit(`ui:${msg.event}`, msg.data)
                if( this.consoleDebug && !['mouse_over_unit','on_camera_update'].includes(msg.event) )
                    console.log(`MAP => UI: ${msg.event}`, msg.data)
            }
            catch(exception) {
                // Not our message?
            }
        },
        setStateGyroscope(value) {
            this.viewApi.config.use_gyroscope_if_available = value;
        },

        showPath(data) {
            setTimeout( () => this.sendMapCommand('showPath', data), 0 )

            //this.$refs.mapFrame.contentWindow.ViewApi.start_guide()
        },
        showPathSteps(data) {
            // this.$refs.mapFrame.contentWindow.ViewApi.go_to_step(data)
        },

        highlightUnits(units) {
            if(!this.listenEvents) return
            if(!units || !units.length) return

            const that = this
            if(!this.viewApi)
                return console.warn('mapApi is not avaliable')
            this.viewApi.restore_base_color();

            units.forEach((unit) =>
                unit.color.indexOf('#') === 0 ?
                    that.viewApi.set_base_hex_color(unit.unit, unit.color) :
                    that.viewApi.set_base_color(unit.unit, unit.color)
            )
        },

        sendMapCommand(event, data){
            this.consoleDebug && console.log(`UI => MAP: ${event}`, JSON.parse(JSON.stringify( data)) )

            if( this.mapDirectCommandMode )
                this.$refs.mapFrame && this.$refs.mapFrame.contentWindow.dmdsMain.handleUIEvent( event, data )
            else
                this.$refs.mapFrame && this.$refs.mapFrame.contentWindow.postMessage(JSON.stringify( { event, data } ), '*')

        },

        stopViewApi() {
            this.viewApi.stop();
        },
        startViewApi() {
            this.viewApi.start();
        },
        responseCameraOrientation() {
            this.$bus.$emit(RESPONSE_CAMERA_ORIENTATION, this.viewApi.camera_controller.current_orientation);
        },
        turnOnDeviceOrientationEvents() {
            this.viewApi.enable_gyroscope_events();
        },
        disableTouchRotation(value) {
            this.viewApi.config.disable_touch_horizontal_rotation = value;
        },
        setNormalizedZoom(data) {
            let zoom = this.viewApi.camera_controller.normalized_zoom;
            if(data.mode === 'zoom') zoom = new Decimal(zoom).minus(new Decimal(0.1));
            else zoom = new Decimal(zoom).plus(new Decimal(0.1));

            this.viewApi.camera_controller.normalized_zoom = zoom;
        },
        getUnitDistances(units) {
            this.sendMapCommand('getUnitDistances', units)
        },

        //Map Event Handlers
        mapLoadingProgressHandler( {progress, label} ){
            this.$bus.$emit('loadingProgress', progress)
            this.$bus.$emit('loadingLabel', label)
        },

        //Map Event Handlers
        mapReadyHandler(){
            this.viewApi = _.get(this.$refs.mapFrame,'contentWindow.ViewApi')
            // Here we need to provide some performance efficient access to viewApi props and methods
            // Using bus/vuex looks not effective here because of high call rate ~60 times a second
            document.viewApi = this.viewApi
            this.isMapReady = true
            this.$nextTick( () => {
                //TODO: Move this logic to the state
                this.$bus.$emit('map:ready')
                this.$bus.$emit(UI_MAP_READY)
                this.$emit('ready', this.viewApi)
            })
        },

        bindEvent(element, eventName, eventHandler) {
            if (element.addEventListener){
                element.addEventListener(eventName, eventHandler, false);
            } else if (element.attachEvent) {
                element.attachEvent(`on${  eventName}`, eventHandler);
            }
        },
        unBindEvent(element, eventName, eventHandler) {
            if (element.removeEventListener){
                element.removeEventListener(eventName, eventHandler, false);
            } else if (element.detachEvent) {
                element.detachEvent(`on${  eventName}`, eventHandler);
            }
        },
    },
    updated(){
    },
    beforeDestroy(){
        this.viewApi && this.viewApi.dispose()
        this.deactivateEventListeners()
    }

}
</script>
<template>
    <div>
        <MvDataLayer v-if="isLoaded" :map-data="mapData"></MvDataLayer>
        <MapLabelsContainer>
            <slot v-if="isMapReady" >
                <OutdoorView></OutdoorView>
            </slot>
            <iframe
                title="Map Viewer"
                ref='mapFrame'
                id="map_viewer_iframe"
                class="mapviewer__iframe"
                :src="mapViewerUrl"
            ></iframe>
        </MapLabelsContainer>
    </div>
</template>
